export default "__VITE_ASSET__B15F$DTK__"